var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"company-list"},[_c('table',[_vm._m(0),_c('tbody',_vm._l((_vm.companies),function(company){return _c('CompanyListItem',{key:company.id,attrs:{"company":company}})}),1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('thead',[_c('tr',[_c('th',[_vm._v("会社名")]),_c('th',[_vm._v("建物名")]),_c('th')])])
}]

export { render, staticRenderFns }